import { useState } from "react";
import { Link } from "react-router-dom"; // Assuming you're using React Router for navigation

function Search() {
  const baseUrl =
    process.env.NODE_ENV === "development"
      ? process.env.REACT_APP_BASE_URL_DEV
      : process.env.REACT_APP_BASE_URL_PROD;

  const [keyword, setKeyword] = useState("");
  const [results, setResults] = useState({ services: [], blogs: [], promotions: [], services1: [] });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showPopup, setShowPopup] = useState(false);

  const handleInputChange = (e) => {
    setKeyword(e.target.value);
  };

  const handleSearch = async () => {
    if (!keyword.trim()) return;

    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${baseUrl}/users/search?keyword=${encodeURIComponent(keyword)}`);
      const data = await response.json();
      setResults(data);
      console.log(data, "jj")
      setShowPopup(true);
    } catch (error) {
      setError("Error fetching search results.");
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearch(); // Trigger search on Enter key press
    }
  };

  const closePopup = () => {
    setShowPopup(false); // Function to close the popup
  };

  return (
    <div className="">
      <div className="relative">
        <input
          type="text"
          value={keyword}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          className="w-[400px] px-4 py-2 border rounded-lg shadow-lg focus:ring-2 focus:outline-none pl-10"
          placeholder="Search by Title..."
        />
        {loading && (
          <div className="absolute right-4 top-4 text-[#11485B] text-lg animate-spin">⏳</div>
        )}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="absolute left-4 top-1/2 transform -translate-y-1/2 text-[#11485B] w-5 h-5"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
      </div>



      {error && <p className="mt-4 text-red-500">{error}</p>}

      {showPopup && (
        <div className="absolute left-[700px] w-[300px] mt-2 bg-white p-4 rounded-lg shadow-lg z-50 max-h-72 overflow-auto">
          <button
            onClick={closePopup}
            className="absolute top-2 right-2 text-[#11485B] hover:text-[#11485B] focus:outline-none transition"
          >
            ✖
          </button>

          <div className="mt-6">
            {results.services.length > 0 && (
              <div className="mb-4">
                <h3 className="text-xl font-semibold text-gray-800 mb-3">Services</h3>
                <ul className="space-y-3">
                  {results.services.map((service) => (
                    <li
                      key={service._id}
                      className="p-3 rounded-md  transition"
                    >
                      <Link
                        to={`/ourservice/${encodeURIComponent(service.title)}?id=${service.categoryId}`}
                        className="text-[#11485B] hover:text-blue-800"
                        onClick={closePopup}
                      >
                        {service.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {results.services1.length > 0 && (
              <div className="mb-4">
                <h3 className="text-xl font-semibold text-gray-800 mb-3">Services</h3>
                <ul className="space-y-3">
                  {results.services1.map((serviceDoc) =>
                    serviceDoc.serviceDetails.length > 0 &&
                    serviceDoc.serviceDetails.map((service) => (
                      <li
                        key={service.subId}
                        className="p-3 rounded-md transition"
                      >
                        <Link
                          to={`/ourservice/${encodeURIComponent(serviceDoc.title)}/${encodeURIComponent(service.serviceName)}?subId=${service.subId}`}
                          className="text-[#11485B] hover:text-blue-800"
                          onClick={closePopup}
                        >
                          {service.serviceName}
                        </Link>
                      </li>
                    ))
                  )}
                </ul>
              </div>
            )}


            {results.promotions.length > 0 && (
              <div className="mb-4">
                <h3 className="text-xl font-semibold text-gray-800 mb-3">Promotions</h3>
                <ul className="space-y-3">
                  {results.promotions.map((promotion) => (
                    <li
                      key={promotion._id}
                      className="p-3  transition"
                    >
                      <Link
                        to={`/promotions/${encodeURIComponent(promotion.title)}?promotionId=${promotion.promotionId}`}
                        className="text-[#11485B] hover:text-blue-800"
                        onClick={closePopup}
                      >
                        {promotion.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/* Blogs */}
            {results.blogs.length > 0 && (
              <div className="mb-4">
                <h3 className="text-xl font-semibold text-gray-800 mb-3">Blogs</h3>
                <ul className="space-y-3">
                  {results.blogs.map((blog) => (
                    <li
                      key={blog.id}
                      className="p-3  transition"
                    >
                      <Link to={`/blog/${encodeURIComponent(blog.title)}?id=${blog.blogId}`}

                        className="text-[#11485B] hover:text-blue-800"
                        onClick={closePopup}
                      >
                        {blog.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {!loading && !error && !results.services.length && !results.blogs.length && !results.promotions.length && (
              <p className="mt-4 text-[#11485B] text-center">No results found.</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default Search;
